import { create } from 'zustand';
import { IWallet } from '@/utils/types/IWallet';
import { ApiRequest } from '@/utils/axios';
import { IDeposit } from '@/utils/types/IDeposit';

interface cryptoState {
    wallets: IWallet[];
    getWallets: () => Promise<any>;
    getWallet: (id: number) => IWallet | undefined;
    rates: IRate[];
    getPrice: (name: string) => number;
    getRates: () => Promise<any>;
    minAmountUsd: number;
    getConfig: () => Promise<any>;
    calculate: (coinName: string, amount: number) => Promise<ICalculateRes>;
    createDeposit: (walletId: number, amountUsd: number) => Promise<IDeposit | undefined>;
    getDeposits: () => Promise<IDeposit[]>;
}

export interface ICalculateRes {
    amountUsd: number;
    amountCoin: number;
    multipliedAmountUsd: number;
}

interface IRate {
    name: string;
    amountUsd: number;
}

export const cryptoStore = create<cryptoState>((set, get) => ({
    wallets: [],
    sendFrom: 0,
    rates: [],
    minAmountUsd: 0,
    getConfig: async () => {
        try {
            const res: {
                data: { response?: { cryptodeposits?: { minAmountUsd?: number } }; success: boolean };
            } = await ApiRequest.get('/settings/list');
            const value = res?.data?.response?.cryptodeposits?.minAmountUsd;
            if (typeof value === 'number' && value > 0) {
                set(() => ({ minAmountUsd: value }));
            }
        } catch {
            /* non-critical */
        }
    },
    getWallets: async () => {
        const res: {
            data: { response?: IWallet[]; success: boolean };
        } = await ApiRequest.get('/cryptodeposits/wallets');
        if (res?.data.success && res?.data?.response) {
            set(() => ({ wallets: res.data.response }));
        }
    },
    getRates: async () => {
        const res: { data: { response?: IRate[]; success: boolean } } =
            await ApiRequest.get('/cryptodeposits/rates');
        if (res?.data.success && res.data.response) {
            set(() => ({ rates: res.data.response }));
        }
    },
    getPrice: (name: string) => {
        return get().rates.find((wallet) => wallet.name == name)?.amountUsd || 0;
    },
    getWallet: (id: number) => {
        return get().wallets.find((wallet) => wallet.id == id);
    },
    calculate: async (coinName: string, amount: number) => {
        const {
            data: { success, response },
        }: {
            data: { success: boolean; response: ICalculateRes };
        } = await ApiRequest.post(`/cryptodeposits/rates/calculate`, {
            coinName,
            amountUsd: amount,
        });
        return response;
    },
    getDeposits: async () => {
        const {
            data: { response },
        }: { data: { response: IDeposit[] } } = await ApiRequest.get('/cryptodeposits/order/list');

        return response;
    },
    createDeposit: async (walletId: number, amountUsd: number) => {
        const {
            data: { success, response },
        }: { data: { success: boolean; response: IDeposit } } = await ApiRequest.post(
            `/cryptodeposits/order/create`,
            {
                walletId,
                amountUsd,
            }
        );
        if (success) return response;

        return undefined;
    },
}));
